import { render, staticRenderFns } from "./textComponents.vue?vue&type=template&id=1478f1e5&scoped=true&lang=pug&"
import script from "./textComponents.vue?vue&type=script&lang=js&"
export * from "./textComponents.vue?vue&type=script&lang=js&"
import style0 from "./textComponents.vue?vue&type=style&index=0&id=1478f1e5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1478f1e5",
  null
  
)

export default component.exports